// Slab PO lines are priced per ft²: actual received ft² for delivered units plus the nominal
// ft² of what is still to come. Sinks (or slabs with no dimensions) stay priced per unit.
export const lineSqft = (l) => {
  if (l.kind === "sink") return null;
  const qty = Number(l.qty) || 0;
  const recvQty = Math.min(Number(l.received_qty) || 0, qty);
  const nominal = ((Number(l.length_in) || 0) * (Number(l.width_in) || 0)) / 144;
  const received = Number(l.received_sqft) || 0;
  if (received <= 0 && nominal <= 0) return null;
  const receivedPart = received > 0 ? received : recvQty * nominal;
  return {
    sqft: receivedPart + Math.max(qty - recvQty, 0) * nominal,
    basis: recvQty > 0 ? "received" : "ordered",
  };
};

export const hasOverride = (l) =>
  l.total_override !== null && l.total_override !== undefined && l.total_override !== "";

// What the line would cost without a manual adjustment.
export const computedLineTotal = (l) => {
  const unit = Number(l.unit_cost) || 0;
  const s = lineSqft(l);
  return unit * (s ? s.sqft : Number(l.qty) || 0);
};

export const lineTotal = (l) =>
  hasOverride(l) ? Number(l.total_override) || 0 : computedLineTotal(l);

export const fmtSqft = (n) =>
  `${(Number(n) || 0).toLocaleString("en-US", { maximumFractionDigits: 1 })} ft²`;
